import type { BillingPeriod, SubscriptionPlan } from '../enums.js';
import { planRank } from './plans.js';

/**
 * Quand un changement d'offre se paie.
 *
 * Monter d'offre (Essentiel → Professionnel → Cabinet) facture tout de suite la différence
 * pour les jours qui restent. Descendre attend la fin de la période déjà payée : l'offre en
 * cours continue jusque-là. Même offre, autre période : l'année se paie maintenant, le retour
 * au mois attend la fin de l'année déjà payée.
 */
export type PlanChangeWhen = 'immediate' | 'period_end';

export function planChangeWhen(
  current: { plan: SubscriptionPlan; period: BillingPeriod },
  next: { plan: SubscriptionPlan; period: BillingPeriod },
): PlanChangeWhen | 'same' {
  if (current.plan === next.plan && current.period === next.period) return 'same';
  const delta = planRank(next.plan) - planRank(current.plan);
  if (delta > 0) return 'immediate';
  if (delta < 0) return 'period_end';
  return next.period === 'annual' ? 'immediate' : 'period_end';
}
